import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AhmedElshahatJobService } from '../../../../../services/ahmed-elshahat-job';
import { CompaniesService } from '../../../../../services/companies';
import { ComplexService } from '../../../../../services/complexrequest';
import { CountryCityService } from '../../../../../services/country-city.service';

@Component({
  selector: 'app-create-job',
  templateUrl: './create-job.component.html',
  styleUrl: './create-job.component.scss'
})
export class CreateJobComponent implements OnInit {

  data!: FormGroup;
  newSkillForm!: FormGroup;

  contentReady: boolean = false;
  isSubmitting: boolean = false;
  isUpdatePage: boolean = false;
  addingSkill: boolean = false;

  jobId: any = null;

  companies: any[] = [];
  complexRequests: any[] = [];

  countries: any[] = [];
  cities: any[] = [];

  skills: any[] = [];
  filteredSkills: any[] = [];

  selectedSkillCategory: string = 'education';

  postedAtArabic: string = '';
  deletedRequirementIds: any[] = [];

  skillCategories = [
    { value: 'education', label: 'تعليم' },
    { value: 'experience', label: 'خبرة' },
    { value: 'certificate', label: 'شهادة' },
    { value: 'language', label: 'لغة' },
    { value: 'technical', label: 'مهارة تقنية' },
    { value: 'soft_skill', label: 'مهارة شخصية' },
    { value: 'other', label: 'أخرى' },
  ];

  constructor(
    private fb: FormBuilder,
    private jobService: AhmedElshahatJobService,
    private route: ActivatedRoute,
    private router: Router,
    private countryCityService: CountryCityService,
    private _complex: ComplexService,
    private _companies: CompaniesService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.createNewSkillForm();

    this.updateArabicPostedAt();

    this.jobId = this.route.snapshot.paramMap.get('id');

    if (this.jobId) {
      this.isUpdatePage = true;
    }

    this.getCompanies();
    this.getComplexRequests();
    this.getSkills();
    this.getCountries();

    if (this.isUpdatePage) {
      this.getJobData();
    } else {
      this.addRequirement();
      this.contentReady = true;
    }
  }

  createForm(): void {
    this.data = this.fb.group({
      user_id: [localStorage.getItem('userId')],

      company_id: [null],
      doctor_id: [null],
      complex_request_id: [null],

      title_en: ['', Validators.required],
      title_ar: ['', Validators.required],

      country_id: [null],
      city_id: [null],

      work_model: ['on_site'],
      job_type: ['any'],
      employment_type: ['full_time'],

      description: [''],
      responsibilities: [''],

      salary_type: ['competitive'],
      salary_min: [null],
      salary_max: [null],
      salary_currency: [''],
      salary_currency_ar: [''],
      salary_note: [''],

      exam_required: [false],
      personality_assessment_required: [false],

      status: ['published'],
      posted_at: [this.getCurrentDateTimeLocal()],

      skills: [[]],

      requirements: this.fb.array([])
    });
  }

  createNewSkillForm(): void {
    this.newSkillForm = this.fb.group({
      name_ar: ['', Validators.required],
      name_en: ['', Validators.required],
    });
  }

  get requirements(): FormArray {
    return this.data.get('requirements') as FormArray;
  }

  getCountries(): void {
    this.countryCityService.getCountries().subscribe({
      next: (res: any) => {
        this.countries = res?.data?.data || res?.data || [];
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  getCitiesByCountry(countryId: any, resetCity: boolean = true): void {
    if (!countryId) {
      this.cities = [];

      if (resetCity) {
        this.data.patchValue({
          city_id: null
        });
      }

      return;
    }

    this.countryCityService.getCitiesByCountry(countryId).subscribe({
      next: (res: any) => {
        this.cities = res?.data?.data || res?.data || [];
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  onCountryChange(): void {
    const countryId = this.data.get('country_id')?.value;

    this.data.patchValue({
      city_id: null
    });

    this.getCitiesByCountry(countryId);
  }

  getCompanies(): void {
    this._companies.getAll(1000, 1).subscribe({
      next: (res: any) => {
        this.companies = res?.data?.data || res?.data || [];
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  getComplexRequests(): void {
    this._complex.getAll(1000, 1).subscribe({
      next: (res: any) => {
        this.complexRequests = res?.data?.data || res?.data || [];
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  getSkills(): void {
    this.jobService.getAllSkills().subscribe({
      next: (res: any) => {
        this.skills = res?.data?.data || res?.data || [];
        this.filterSkillsByCategory();
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  getJobData(): void {
    this.contentReady = false;

    this.jobService.getJob(this.jobId).subscribe({
      next: (res: any) => {
        const job = res.data;

        this.data.patchValue({
          user_id: job.user_id,
          company_id: job.company_id,
          doctor_id: job.doctor_id,
          complex_request_id: job.complex_request_id,

          title_en: job.title_en,
          title_ar: job.title_ar,

          country_id: job.country_id,
          city_id: job.city_id,

          work_model: job.work_model || 'on_site',
          job_type: job.job_type || 'any',
          employment_type: job.employment_type || 'full_time',

          description: job.description || '',
          responsibilities: job.responsibilities || '',

          salary_type: job.salary_type || 'competitive',
          salary_min: job.salary_min,
          salary_max: job.salary_max,
          salary_currency: job.salary_currency || '',
          salary_currency_ar: job.salary_currency_ar || '',
          salary_note: job.salary_note || '',

          exam_required: this.toBoolean(job.exam_required),
          personality_assessment_required: this.toBoolean(job.personality_assessment_required),

          status: job.status || 'published',
          posted_at: this.formatDateTimeLocal(job.posted_at),

          skills: job.skills ? job.skills.map((skill: any) => skill.id) : []
        });

        if (job.country_id) {
          this.getCitiesByCountry(job.country_id, false);
        }

        this.updateArabicPostedAt();

        this.requirements.clear();

        if (job.requirements && job.requirements.length > 0) {
          job.requirements.forEach((item: any) => {
            this.addRequirement(item);
          });
        } else {
          this.addRequirement();
        }

        this.contentReady = true;
      },
      error: (err: any) => {
        console.log(err);
        this.contentReady = true;
      }
    });
  }

  selectSkillCategory(category: string): void {
    this.selectedSkillCategory = category;

    this.newSkillForm.reset({
      name_ar: '',
      name_en: '',
    });

    this.filterSkillsByCategory();
  }

  filterSkillsByCategory(): void {
    this.filteredSkills = this.skills.filter((skill: any) => {
      return skill.category === this.selectedSkillCategory;
    });
  }

  getSkillName(skill: any): string {
    if (!skill) {
      return '';
    }

    if (skill.name_ar && skill.name_en) {
      return `${skill.name_ar} - ${skill.name_en}`;
    }

    return skill.name_ar || skill.name_en || skill.name || 'مهارة بدون اسم';
  }

  addSkillFromJobForm(): void {
    if (this.newSkillForm.invalid) {
      this.newSkillForm.markAllAsTouched();
      return;
    }

    this.addingSkill = true;

    const formValue = this.newSkillForm.value;

    const payload = {
      name_ar: formValue.name_ar,
      name_en: formValue.name_en,
      slug_ar: null,
      slug_en: null,
      category: this.selectedSkillCategory
    };

    this.jobService.addSkill(payload).subscribe({
      next: (res: any) => {
        this.addingSkill = false;

        const newSkill = res?.data;

        if (newSkill) {
          this.skills.unshift(newSkill);
          this.filterSkillsByCategory();
          this.addSkillToSelectedSkills(newSkill.id);
        }

        this.newSkillForm.reset({
          name_ar: '',
          name_en: '',
        });
      },
      error: (err: any) => {
        console.log(err);
        this.addingSkill = false;

        if (err?.error?.errors?.name_ar) {
          alert(err.error.errors.name_ar[0]);
        } else if (err?.error?.errors?.name_en) {
          alert(err.error.errors.name_en[0]);
        } else if (err?.error?.message) {
          alert(err.error.message);
        } else {
          alert('حدث خطأ أثناء إضافة المهارة');
        }
      }
    });
  }

  addSkillToSelectedSkills(skillId: any): void {
    const selectedSkills = [...(this.data.value.skills || [])];

    if (!selectedSkills.includes(skillId)) {
      selectedSkills.push(skillId);
    }

    this.data.patchValue({
      skills: selectedSkills
    });
  }

  toggleSkill(skillId: any, event: any): void {
    const selectedSkills = [...(this.data.value.skills || [])];

    if (event.target.checked) {
      if (!selectedSkills.includes(skillId)) {
        selectedSkills.push(skillId);
      }
    } else {
      const index = selectedSkills.indexOf(skillId);

      if (index > -1) {
        selectedSkills.splice(index, 1);
      }
    }

    this.data.patchValue({
      skills: selectedSkills
    });
  }

  isSkillSelected(skillId: any): boolean {
    return (this.data.value.skills || []).includes(skillId);
  }

  addRequirement(item: any = null): void {
    const requirementGroup = this.fb.group({
      id: [item?.id || null],
      requirement_text: [item?.requirement_text || '', Validators.required],
      requirement_type: [item?.requirement_type || 'other'],
      is_required: [this.toBoolean(item?.is_required ?? true)]
    });

    this.requirements.push(requirementGroup);
  }

  removeRequirement(index: number): void {
    const requirement = this.requirements.at(index).value;

    if (requirement.id) {
      this.deletedRequirementIds.push(requirement.id);
    }

    this.requirements.removeAt(index);
  }

  openDatePicker(input: HTMLInputElement): void {
    input.focus();

    if ((input as any).showPicker) {
      (input as any).showPicker();
    } else {
      input.click();
    }
  }

  onPostedAtChange(event: any): void {
    const value = event.target.value;

    this.data.patchValue({
      posted_at: value
    });

    this.updateArabicPostedAt();
  }

  updateArabicPostedAt(): void {
    const value = this.data.get('posted_at')?.value;

    if (!value) {
      this.postedAtArabic = '';
      return;
    }

    const date = new Date(value);

    this.postedAtArabic = new Intl.DateTimeFormat('ar-EG-u-nu-arab', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
  }

  getCurrentDateTimeLocal(): string {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  formatDateTimeLocal(date: any): any {
    if (!date) {
      return null;
    }

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  emptyToNull(value: any): any {
    if (value === '' || value === undefined || value === null) {
      return null;
    }

    return value;
  }

  toBoolean(value: any): boolean {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  onSubmit(): void {
    if (this.data.invalid) {
      this.data.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const formValue = this.data.value;

    const jobPayload = {
      user_id: this.emptyToNull(formValue.user_id),

      company_id: this.emptyToNull(formValue.company_id),
      doctor_id: this.emptyToNull(formValue.doctor_id),
      complex_request_id: this.emptyToNull(formValue.complex_request_id),

      title_en: formValue.title_en,
      title_ar: formValue.title_ar,

      country_id: this.emptyToNull(formValue.country_id),
      city_id: this.emptyToNull(formValue.city_id),

      work_model: formValue.work_model,
      job_type: formValue.job_type || 'any',
      employment_type: formValue.employment_type,

      description: formValue.description,
      responsibilities: formValue.responsibilities,

      salary_type: formValue.salary_type,
      salary_min: this.emptyToNull(formValue.salary_min),
      salary_max: this.emptyToNull(formValue.salary_max),
      salary_currency: formValue.salary_currency,
      salary_currency_ar: formValue.salary_currency_ar,
      salary_note: formValue.salary_note,

      exam_required: formValue.exam_required ? 1 : 0,
      personality_assessment_required: formValue.personality_assessment_required ? 1 : 0,

      status: formValue.status,
      posted_at: formValue.posted_at,

      skills: formValue.skills || [],

      requirements: (formValue.requirements || []).map((req: any) => {
        return {
          id: req.id,
          requirement_text: req.requirement_text,
          requirement_type: req.requirement_type,
          is_required: req.is_required ? 1 : 0
        };
      }),

      deleted_requirement_ids: this.deletedRequirementIds
    };

    const request = this.isUpdatePage
      ? this.jobService.updateJob(this.jobId, jobPayload)
      : this.jobService.addJob(jobPayload);

    request.subscribe({
      next: () => {
        this.isSubmitting = false;
        this.router.navigate(['/alljobs']);
      },
      error: (err: any) => {
        console.log(err);
        this.isSubmitting = false;

        if (err?.error?.message) {
          alert(err.error.message);
        } else {
          alert('حدث خطأ أثناء حفظ الوظيفة');
        }
      }
    });
  }
}